import { Component, Input, OnInit } from '@angular/core';
import { RmService } from '@bidi/common-services';
import { createFeatureSelector, select, Store } from '@ngrx/store';
import { ViewState } from '@angular/core/src/view';

import { RatingsService } from './../ratings.service';

@Component({
  selector: 'bidi-content-ratings',
  templateUrl: './content-ratings.component.html',
  styleUrls: ['./content-ratings.component.scss']
})
export class ContentRatingsComponent implements OnInit {
  @Input() resourceId;
  @Input() typeData = 'tt';
  @Input() views;
  @Input() showOpinions;
  averageTeacher = 0;
  averageStudent = 0;
  average = 100;
  averageStudentCal = 100;
  voteC = false;
  totalStudent = 0;
  totalTeacher = 0;
  total = 0;

  private state$ = this.store.pipe(select(createFeatureSelector('@bidi/common-components Ratings')));

  constructor (
    private rm: RmService,
    public ratingsService: RatingsService,
    private store: Store<any>
  ) {
  }

  ngOnInit () {
    if (this.resourceId) {
      this.ratingsService.getRatings(this.resourceId);
      const resourceId = this.resourceId;
      this.ratingsService.ratings$.subscribe(
        data => {
          let range = 0;
          let rangeTeachers = 0;
          let totalTeachers = 0;
          let rangeStudent = 0;
          let totalStudent = 0;
          let total = 0;
          let average = 100;
          data.map(function (d) {
            if (d.id === resourceId) {
              if (d.ratings && d.ratings.length > 0 ) {
                d.ratings.map(function (r) {
                  range = range + parseInt(r.range, 0);
                  if (r.type === 'teacher') {
                    rangeTeachers = rangeTeachers + parseInt(r.range, 0);
                    totalTeachers++;
                  }
                  if (r.type === 'student') {
                    rangeStudent = rangeStudent + parseInt(r.range, 0);
                    totalStudent++;
                  }
                  total++;
                });
              }
            }
          });
          average = range / total;
          this.average = (total === 0) ? 100 : (5 - average) * 20;
          this.averageStudentCal = (totalStudent === 0) ? 100 : (5 - (rangeStudent / totalStudent)) * 20;
          this.averageTeacher = (totalTeachers === 0) ? 0 : rangeTeachers / totalTeachers;
          this.averageStudent = (totalStudent === 0) ? 0 : rangeStudent / totalStudent;
          this.totalStudent = totalStudent;
          this.totalTeacher = totalTeachers;
          this.total = total;
        }
      );
    }
  }

}
